import { useState, useCallback } from 'react'
import { apiService } from '../services/api'
import { Vehicle } from '../types'

export type { Vehicle }

export const useVehicles = () => {
 const [vehicles, setVehicles] = useState<Vehicle[]>([])
 const [isLoading, setIsLoading] = useState(false)
 const [error, setError] = useState<string | null>(null)
 const [pagination, setPagination] = useState({
 page: 1,
 limit: 50,
 total: 0,
 totalPages: 0
 })

 const fetchVehicles = useCallback(async (params?: {
 page?: number
 limit?: number
 search?: string
 status?: string
 category?: string
 }) => {
 try {
 setIsLoading(true)
 setError(null)
 const response = await apiService.getVehicles(params)
 
 if (response && typeof response === 'object' && 'vehicles' in response) {
 setVehicles(response.vehicles || [])
 if (response.pagination) {
 setPagination({
 page: response.pagination.page,
 limit: response.pagination.limit,
 total: response.pagination.total,
 totalPages: response.pagination.pages
 })
 }
 } else if (Array.isArray(response)) {
 setVehicles(response)
 } else {
 setVehicles([])
 }
 } catch (err) {
 console.error('Erro ao carregar veículos:', err)
 setError('Erro ao carregar veículos. Tente novamente.')
 setVehicles([])
 } finally {
 setIsLoading(false)
 }
 }, [])

 // Removido useEffect automático - carregamento deve ser manual quando necessário

 const deleteVehicle = useCallback(async (vehicleId: string) => {
 try {
 await apiService.deleteVehicle(vehicleId)
 // Refresh the vehicles list after deletion
 await fetchVehicles({ page: pagination.page, limit: pagination.limit })
 } catch (err) {
 console.error('Erro ao deletar veículo:', err)
 throw err
 }
 }, [fetchVehicles, pagination.page, pagination.limit])

 return {
 vehicles,
 isLoading,
 error,
 pagination,
 page: pagination.page,
 fetchVehicles,
 deleteVehicle
 }
}